// Đếm phễu đặt lịch công khai: xem trang → chọn giờ → bấm đặt.
//
// Ba mốc này trả lời câu "khách rơi ở đâu" ở tab Phân tích kinh doanh. Không
// có nó thì chỉ biết bao nhiêu người ĐẶT XONG, không biết bao nhiêu người vào
// rồi bỏ đi và bỏ ở bước nào.
//
// 🔒 KHÔNG GỬI GÌ TRUY RA ĐƯỢC NGƯỜI. Khoá phiên là chuỗi ngẫu nhiên do trình
// duyệt tự sinh, sống trong sessionStorage của đúng tab đó. Tuyệt đối không
// thay bằng số điện thoại/email — trang này CÔNG KHAI, không đăng nhập, và
// endpoint nhận sự kiện cũng công khai.
import { resolvePublicBookingApiUrl } from "./api";

export type FunnelStep = "view" | "slot_selected" | "submitted";

const STORAGE_KEY = "gnpf_booking_funnel_session";

/** Bước đã bắn trong phiên này — chặn đếm trùng khi React render lại. */
const sent = new Set<FunnelStep>();

function randomKey(): string {
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(bytes);
  } else {
    // Không có crypto (môi trường kiểm thử cũ): số kém ngẫu nhiên vẫn dùng
    // được vì đây chỉ là khoá gộp phiên, không phải khoá bảo mật.
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

/**
 * Khoá phiên, giữ nguyên trong suốt một lượt ngồi đặt lịch.
 *
 * sessionStorage ném lỗi ở chế độ riêng tư của một số trình duyệt — bắt hết và
 * quay về khoá tạm trong bộ nhớ. Một phép ĐO không bao giờ được làm hỏng việc
 * ĐẶT LỊCH của khách.
 */
let memoryKey = "";
export function funnelSessionKey(): string {
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const key = randomKey();
    sessionStorage.setItem(STORAGE_KEY, key);
    return key;
  } catch {
    if (!memoryKey) memoryKey = randomKey();
    return memoryKey;
  }
}

/**
 * Bắn một mốc phễu. Gửi rồi quên: không await, không toast, không throw.
 *
 * `keepalive` để lượt "submitted" vẫn đi được khi trang đang chuyển sang màn
 * kết quả — không có cờ này thì trình duyệt huỷ request giữa chừng và bước
 * cuối của phễu luôn thấp giả.
 */
export function trackFunnel(step: FunnelStep, branch?: string): void {
  if (sent.has(step)) return;
  sent.add(step);
  try {
    const body = JSON.stringify({
      sessionKey: funnelSessionKey(),
      step,
      ...(branch ? { branch } : {}),
    });
    void fetch(resolvePublicBookingApiUrl("/public/booking-funnel/events"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {
      // Im lặng có chủ đích: khách đang đặt lịch không cần biết phép đo của
      // marketing vừa hỏng.
    });
  } catch {
    // Như trên.
  }
}

/** Chỉ dùng trong test — xoá trí nhớ "đã bắn" giữa hai bài. */
export function resetFunnelForTest(): void {
  sent.clear();
  memoryKey = "";
}
